import { useEffect, useState } from "react";
import { SubstackIcon } from "@/components/BrandIcons";
import ThreadsLogo from "@/components/ThreadsLogo";

function useCountdown(target) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const diff = Math.max(0, target - now);
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return { d, h, m, s };
}

function SoonShell({ accent, icon, kicker, title, lines, target, footnote }) {
  const { d, h, m, s } = useCountdown(target);
  const cells = [
    [d, "days"], [h, "hrs"], [m, "min"], [s, "sec"],
  ];
  return (
    <div className="h-full flex flex-col items-center justify-center gap-5 p-6 text-center bg-[#0c0c0e] text-white mac-scroll overflow-auto"
      style={{ backgroundImage: `radial-gradient(ellipse at 50% 120%, ${accent}22 0%, transparent 60%)` }}>
      <div className="w-14 h-14 rounded-2xl flex items-center justify-center" style={{ background: accent }}>
        {icon}
      </div>
      <div>
        <div className="text-[11px] tracking-[0.3em] uppercase text-white/40">{kicker}</div>
        <div className="text-2xl font-bold mt-1" data-testid="coming-soon-title">{title}</div>
      </div>
      <div className="flex flex-col gap-1.5">
        {lines.map((l, i) => (
          <div key={i} className="text-sm text-white/60">{l}</div>
        ))}
      </div>
      <div className="flex gap-2.5">
        {cells.map(([v, label]) => (
          <div key={label} className="flex flex-col items-center">
            <div className="w-14 py-2.5 rounded-xl bg-white/5 border border-white/10 text-xl font-bold tabular-nums">
              {String(v).padStart(2, "0")}
            </div>
            <div className="text-[10px] uppercase tracking-widest text-white/35 mt-1">{label}</div>
          </div>
        ))}
      </div>
      <div className="text-xs text-white/35">{footnote}</div>
    </div>
  );
}

// Rolling launch targets (~3 weeks out) so the countdowns stay alive until real dates exist
const SUBSTACK_TARGET = Date.now() + 21 * 86400000;
const THREADS_TARGET = Date.now() + 28 * 86400000;

export function SubstackSoon() {
  return (
    <SoonShell
      accent="#ff6719"
      icon={<SubstackIcon size={26} className="text-white" />}
      kicker="Coming soon"
      title="The Substack is being written"
      lines={[
        "Long-form notes on discipline, family and the work.",
        "First essays are in drafts now.",
      ]}
      target={SUBSTACK_TARGET}
      footnote="The link goes live here the day it launches."
    />
  );
}

export function ThreadsSoon() {
  return (
    <SoonShell
      accent="#e8c547"
      icon={<ThreadsLogo size={32} />}
      kicker="Coming soon"
      title="September Threads"
      lines={[
        "A small run of tees. Built to be earned, not just worn.",
        "First drop is in production.",
      ]}
      target={THREADS_TARGET}
      footnote="The shop link goes live here at launch."
    />
  );
}
